export function updateHeadLink(rel: string, href: string) {
  let link = document.querySelector('link[rel="' + rel + '"]') as HTMLLinkElement | null;

  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }

  if (link.href !== href) {
    link.href = href;
  }
}

export function normalizeAppPath(path: string) {
  if (!path) return '/';
  return path.startsWith('/') ? path : '/' + path;
}
